(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-review"] && !Shopify.designMode) return;
  try {
    
(function() {

  const track   = document.getElementById('bd-track');
  const prevBtn = document.getElementById('bd-prev');
  const nextBtn = document.getElementById('bd-next');

  if (!track) return;

  const cards = track.querySelectorAll('.bd-card');
  const GAP = 20;

  function cardWidth() {
    return window.innerWidth <= 768 ? 190 : 230;
  }

  function stepSize() {
    return cardWidth() + GAP;
  }

  function visibleCount() {
    return window.innerWidth <= 768 ? 2 : 5;
  }

  let idx = 0;

  function maxIdx() {
    return Math.max(0, cards.length - visibleCount());
  }

  function slide() {
    track.style.transform =
      'translateX(-' + (idx * stepSize()) + 'px)';
  }

  // ===== BUTTONS =====

  nextBtn.addEventListener('click', function() {
    idx = idx < maxIdx() ? idx + 1 : 0;
    slide();
  });

  prevBtn.addEventListener('click', function() {
    idx = idx > 0 ? idx - 1 : maxIdx();
    slide();
  });

  // ===== TOUCH SWIPE =====

  let startX = 0;
  let endX = 0;

  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  });

  track.addEventListener('touchmove', function(e) {
    endX = e.touches[0].clientX;
  });

  track.addEventListener('touchend', function() {

    let diff = startX - endX;

    if (diff > 50) {
      idx = idx < maxIdx() ? idx + 1 : 0;
      slide();
    }

    if (diff < -50) {
      idx = idx > 0 ? idx - 1 : maxIdx();
      slide();
    }

  });

  // ===== MOUSE DRAG SUPPORT =====

  let isDragging = false;
  let dragStartX = 0;
  let dragEndX = 0;

  track.style.cursor = "grab";

  track.addEventListener("mousedown", function(e) {
    isDragging = true;
    dragStartX = e.clientX;
    track.style.cursor = "grabbing";
  });

  track.addEventListener("mousemove", function(e) {
    if (!isDragging) return;
    dragEndX = e.clientX;
  });

  track.addEventListener("mouseup", function() {

    if (!isDragging) return;

    let diff = dragStartX - dragEndX;

    if (diff > 50) {
      idx = idx < maxIdx() ? idx + 1 : 0;
      slide();
    }

    if (diff < -50) {
      idx = idx > 0 ? idx - 1 : maxIdx();
      slide();
    }

    isDragging = false;
    track.style.cursor = "grab";
  });

  track.addEventListener("mouseleave", function() {
    isDragging = false;
    track.style.cursor = "grab";
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
